import Vue from 'vue';

Vue.component('loyalty-redemption', () =>
    import(/* webpackChunkName: 'loyalty-redemption' */ './loyalty-redemption.vue'),
);

Vue.component('loyalty-settings', () =>
    import(/* webpackChunkName: 'loyalty-settings' */ './loyalty-settings.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/loyalty/index.js